import styled from 'styled-components'
import {
  CircleAccent,
  SectionHeader,
  CalendarGrid,
} from '../ContentBlocks/styles/CalendarOfEventsBlock.styles'

export const HeaderContainer = styled(CalendarGrid)`
  grid-column: 2 / 3;
  margin-top: 40px;
`

export const RelatedProductsCircleAccent = styled(CircleAccent)`
  border: 3px solid var(--graphic-accent-purple-1);
  grid-column: 1;
`

export const RelatedProductsSectionHeader = styled(SectionHeader)`
  grid-column: 1;
`

export const RelatedProductsGridContainer = styled.div`
  grid-column: 2 / 3;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
  column-gap: 32px;

  @media screen and (min-width: 870px) {
    grid-template-columns: repeat(auto-fill, 400px);
  }

  @media screen and (min-width: 1350px) {
    grid-template-columns: repeat(auto-fill, 311px);
  }
`
